module.exports = "/_next/static/images/Hero-md@2x-0ac6cbf125809934aa639e11b5729b77.png";